/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';
import { JobDetailsDrawsTabComponent, JobDrawDetailsTabBusinessService } from '@gh/builder-shared';

import { createRoute } from '@gh/common-shared';

import { DrawDetailsComponent } from './components/draw-details/draw-details.component';
import { XeroIssueLogListComponent } from './components/xero-issue-log-list';
import { XeroSyncComponent } from './components/xero-sync';
import { XeroIssueLogBusinessService, XeroSyncBusinessService } from './resources';
import { DrawDetailsBusinessService } from './resources/draw-details-business.service';
import { DrawListBusinessService } from './resources/draw-list-business.service';
import { DrawListComponent } from './components/draw-list/draw-list.component';
import { DrawDetailsMakeDrawTabComponent } from './components/draw-details/draw-details-make-draw-tab/draw-details-make-draw-tab.component';
import { ViewDrawDetailsComponent } from './components/view-draw-details/view-draw-details.component';

const routes: Routes = [
  createRoute({
    component: XeroIssueLogListComponent,
    path: 'xero-issue-log',
    init: XeroIssueLogBusinessService,
    auth: {
      permission: 'XeroIssueLog.VIEW',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'draws',
    component: DrawListComponent,
    init: {
      service: DrawListBusinessService,
      selector: 'initView',
    },
    auth: {
      permission: 'Accounting.Draws.LIST',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'draws/:jobId',
    component: DrawDetailsComponent,
    init: DrawDetailsBusinessService,
    auth: {
      permission: 'Accounting.Draws.PRODUCE',
      applicationView: APPLICATION_VIEW_OFFICE,
    },
    children: [
      createRoute({
        component: DrawDetailsMakeDrawTabComponent,
        path: 'make-draw',
        init: {
          service: DrawDetailsBusinessService,
          selector: 'initMakeView',
        },
      }),
      createRoute({
        component: JobDetailsDrawsTabComponent,
        path: 'draw-details',
        leave: true,
        init: {
          service: JobDrawDetailsTabBusinessService,
          selector: 'initDrawsTabView',
        },
      }),
    ],
  }),
  createRoute({
    path: 'jobs/:jobId/draws/:invoiceId',
    component: ViewDrawDetailsComponent,
    init: {
      service: DrawDetailsBusinessService,
      selector: 'initInvoiceView',
    },
    auth: {
      permission: [
        'Accounting.Draws.PRODUCE',
        'Accounting.Draws.VIEW',
      ],
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
  createRoute({
    path: 'xero-sync',
    component: XeroSyncComponent,
    init: XeroSyncBusinessService,
    auth: {
      permission: [
        'Accounting.Sync.INITIATE',
      ],
      applicationView: APPLICATION_VIEW_OFFICE,
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderAccountingRoutingModule {
}
